/**
 * Server error codes.
 * https://github.com/otter-ai/recall-api/blob/f1a711a4b090fd96f696bad215ea3170c2a87362/api/constants.py#L238
 */
export const CODE_NOT_LOGIN = 1;
export const CODE_INVALID_EMAIL = 4;
export const CODE_INVALID_PASSWORD = 5;
export const CODE_EMAIL_CONFLICT = 7;
export const CODE_NO_PERMISSION = 8;
export const CODE_INVALID_TOKEN = 9;
export const CODE_MISSING_INPUT = 10;
export const CODE_INVALID_INPUT = 16;
export const CODE_NOT_FOUND = 21;
export const CODE_VALIDATION_ERROR = 25;
export const CODE_NO_MINUTE_QUOTA = 26;
export const CODE_REQUIRE_TWO_FACTOR = 36;
export const CODE_TWO_FACTOR_FAILED = 37;
export const CODE_INVALID_CSRF = 42;
export const CODE_NO_PERMISSION_SSO = 47;
export const CODE_TERMS_NOT_AGREED = 48;
export const CODE_USER_NOT_MATCH = 108;
export const CODE_TRANSCRIPT_OUTDATED = 34;
export const CODE_SESSION_CONFLICT = 32;
export const API_STATUS_FAILED = 'failed';
export const API_STATUS_OK = 'OK';
